const buildPerUserKey = (keyPrefix: string, oktaUserId: string): string =>
  `${keyPrefix}-${oktaUserId}`;

export const readPerUserCount = (
  keyPrefix: string,
  oktaUserId: string
): number => {
  try {
    const stored = window.localStorage.getItem(
      buildPerUserKey(keyPrefix, oktaUserId)
    );
    const parsed = stored ? Number.parseInt(stored, 10) : 0;

    return Number.isNaN(parsed) ? 0 : parsed;
  } catch {
    return 0;
  }
};

export const incrementPerUserCount = (
  keyPrefix: string,
  oktaUserId: string
): void => {
  try {
    window.localStorage.setItem(
      buildPerUserKey(keyPrefix, oktaUserId),
      String(readPerUserCount(keyPrefix, oktaUserId) + 1)
    );
  } catch {}
};

export const readPerUserFlag = (
  keyPrefix: string,
  oktaUserId: string
): boolean => {
  try {
    return (
      window.localStorage.getItem(buildPerUserKey(keyPrefix, oktaUserId)) ===
      'true'
    );
  } catch {
    return false;
  }
};

export const setPerUserFlag = (keyPrefix: string, oktaUserId: string): void => {
  try {
    window.localStorage.setItem(buildPerUserKey(keyPrefix, oktaUserId), 'true');
  } catch {}
};
